/**
 * 容器数据实体
 * cid: 容器id
 * create: 创建于基于播放时间的时间点，对应time属性
 * destroy: 销毁于基于播放时间的时间点，对应time属性
 * createUID: 创建于基于播放时间点的uid时间戳属性，对应uniqueID
 * destroyUID: 销毁于基于播放时间点的uid时间戳属性，对应uniqueID
 * type: 该容器是文档类型还是白板类型
 *
 * @export
 * @class CIDInfo
 */
export default class CIDInfo {
  constructor() {
    this.cid = '';
    this._create = -1;
    this._createUID = -1;
    this.destroy = Number.MAX_SAFE_INTEGER;
    this.destroyUID = Number.MAX_SAFE_INTEGER;
    this.type = '';
    this.backgroundColor = '';
    this.backgroundImage = '';
    // 如果是文档的话， width 和 height 分别是文档的宽高。
    // 如果是白板的话， width 和 height 分别是白板容器的宽高。
    this.width = 0;
    this.height = 0;
  }

  toString() {
    return `容器id: ${this.cid},类型: ${this.type},创建时间: ${this.create},创建绝对时间: ${this.createUID},销毁时间: ${this.destroy},销毁绝对时间: ${this.destroyUID}`;
  }

  set create(val) {
    if (this._create > val || this._create === -1) {
      this._create = val;
    }
  }

  get create() {
    return this._create;
  }

  set createUID(val) {
    if (this._createUID === -1 || this._createUID > val) {
      this._createUID = val;
    }
  }

  get createUID() {
    return this._createUID;
  }

  set data(val) {
    this._data = val;
    const data = this._data;

    if (data.hasOwnProperty('hash')) {
      const hash = data['hash'];
      this.type = hash === '' ? 'Board' : 'Document';
      this.createUID = data['uniqueID'];
      if (data.hasOwnProperty('command')) {
        let commands = data['command'];
        if (commands.length > 0) {
          let command = commands[0];
          this.type = command.is_board === 1 ? 'Document' : 'Board';

          // 以防万一
          if (this.cid.indexOf('board') > -1) {
            this.type = 'Board';
          } else {
            this.type = 'Document';
          }

          // switch(command['type']) {}
          if (command['type'] === 'destroy') {
            this.destroy = this._origin['created_at'];
            this.destroyUID = data['uniqueID'];
          }

          if (command['type'] === 'create') {
            const cmdData = command['data'];
            this.backgroundColor = cmdData['backgroundColor'];
          }
        }

        if (this.type === 'Document' && data['flipOver'] === 1) {
          this.width = data['width'];
          this.height = data['height'];
        } else if (this.type === 'Board') {
          this.width = data['cw'];
          this.height = data['ch'];
        }
      }
    } else {
      // 没有hash，基本就是，创建、销毁、选择等
      switch (data.type) {
        case 'create':
          this.createUID = data['uniqueID'];
          this.type = data['container'];
          this.backgroundColor = data['backgroundColor'];
          break;
        case 'destroy':
          this.destroyUID = data['uniqueID'];
          this.destroy = this._origin && this.origin['created_at'];
          break;
        default:
          break;
      }
    }
  }

  set origin(val) {
    // {content:{}, create_at:xx,content2:{}}
    this._origin = val;
  }
}
